import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Choose from '@/views/Choose.vue'
import Login from '@/views/Login.vue'
import RequestLoginData from '@/views/RequestLoginData.vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import { API } from "@/api.js";

const jwt = require("jsonwebtoken");

Vue.use(VueRouter)
Vue.component('v-icon', Icon)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/choose',
        name: 'Choose',
        component: Choose
    },
    {
        path: '/rld',
        name: 'RequestLoginData',
        component: RequestLoginData
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/pinfomacchina',
        name: 'PInfoMacchina',
        component: () => import(/* webpackChunkName: "machineinfo" */ '@/views/prodinst/PInfoMacchina.vue')
    },
    {
        path: '/picalendar',
        name: 'PICalendar',
        component: () => import(/* webpackChunkName: "billofmaterials" */ '@/views/prodinst/PICalendar.vue')
    },
    {
        path: '/pimymachines',
        name: 'PIMyMachines',
        component: () => import(/* webpackChunkName: "billofmaterials" */ '@/views/prodinst/PIMyMachines.vue')
    },
    {
        path: '/piopenpointslist',
        name: 'PIIssues',
        component: () => import(/* webpackChunkName: "billofmaterials" */ '@/views/prodinst/PIIssues.vue')
    },
    {
        path: '/piallmachines',
        name: 'PISearch',
        component: () => import(/* webpackChunkName: "billofmaterials" */ '@/views/prodinst/PISearch.vue')
    },
    {
        path: '/pimachinearchive',
        name: 'PIArchive',
        component: () => import(/* webpackChunkName: "billofmaterials" */ '@/views/prodinst/PIArchive.vue')
    },
    {
        path: '/practions',
        name: 'Actions',
        component: () => import(/* webpackChunkName: "billofmaterials" */ '@/views/prodinst/Actions.vue')
    },
    {
        path: '/scbillofmaterials',
        name: 'BillOfMaterials',
        component: () => import(/* webpackChunkName: "billofmaterials" */ '@/views/BillOfMaterials.vue')
    },
    {
        path: '/scrfq',
        name: 'RFQ',
        component: () => import(/* webpackChunkName: "rfq" */ '@/views/RFQ.vue')
    },
    {
        path: '/scmachines',
        name: 'Machines',
        component: () => import(/* webpackChunkName: "machines" */ '@/views/Machines.vue')
    },
    {
        path: '/scinfomacchina',
        name: 'MachineInfo',
        component: () => import(/* webpackChunkName: "machineinfo" */ '@/views/InfoMacchina.vue')
    },
    {
        path: '/sctickets',
        name: 'Tickets',
        component: () => import(/* webpackChunkName: "tickets" */ '@/views/Tickets.vue')
    },
    {
        path: '/scspareparts',
        name: 'SpareParts',
        component: () => import(/* webpackChunkName: "spareparts" */ '@/views/SpareParts.vue')
    },
    {
        path: '/scassistance',
        name: 'Assistance',
        component: () => import(/* webpackChunkName: "spareparts" */ '@/views/Assistance.vue')
    },
    {
        path: '/screpairs',
        name: 'Repairs',
        component: () => import(/* webpackChunkName: "spareparts" */ '../views/Repairs.vue')
    },
    {
        path: '/screminders',
        name: 'Reminders',
        component: () => import(/* webpackChunkName: "spareparts" */ '@/views/Reminders.vue')
    },
    {
        path: '/sccontracts',
        name: 'Contracts',
        component: () => import(/* webpackChunkName: "contracts" */ '@/views/Contracts.vue')
    },
    {
        path: '/scarch',
        name: 'News',
        component: () => import(/* webpackChunkName: "news" */ '@/views/News.vue')
    },
    {
        path: '/users',
        name: 'Users',
        props: { table: 'users' },
        component: () => import(/* webpackChunkName: "users" */ '@/views/Tabella.vue')
    },
    {
        path: '/pimachinesstatus',
        name: 'MachinesStatus',
        props: { table: 'unitstatus' },
        component: () => import(/* webpackChunkName: "users" */ '@/views/Tabella.vue')
    },
    {
        path: '/siteadmin',
        name: 'SiteAdmin',
        props: { table: 'users' },
        component: () => import(/* webpackChunkName: "siteadmin" */ '@/views/SiteAdmin.vue')
    },
    {
        path: '/logs',
        name: 'Logs',
        props: { url: 'report.html' },
        component: () => import(/* webpackChunkName: "logs" */ '@/views/IFrame.vue')
    },
    {
        path: '/logs2',
        name: 'Logs2',
        props: { table: 'logs' },
        component: () => import(/* webpackChunkName: "logs" */ '@/views/Logs2.vue')
    },
    {
        path: '/overrides',
        name: 'Overrides',
        props: { table: 'possible_units' },
        component: () => import(/* webpackChunkName: "overrides" */ '@/views/Tabella.vue')
    },
    {
        path: '/support',
        name: 'Support',
        component: () => import(/* webpackChunkName: "support" */ '@/views/Support.vue')
    },
]

const router = new VueRouter({
    routes
})

// verifico il token
// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
    if (to.name != 'Login' && to.name != 'Home' && to.name != 'RequestLoginData') {
        let token = localStorage.getItem("jwt");
        // console.log("token", token);
        console.log("router", to, from)
        if (token) {
            try {
                API.navlog(to.name)
            } catch (error) {
                console.error("NAV", error)
            }
            try {
                // qui non ho la chiave "secret" e non voglio averla. Mi interessa solo sapere se il token
                // è scaduto in modo tale da non provare ad utilizzarlo per niente (tanto poi le API lo rifiuterebbero)
                const { exp } = jwt.decode(token);
                const now = (new Date().getTime() + 1) / 1000
                console.log("payload:", exp - now)
                if (exp < now) {
                    console.log("token scaduto")
                    localStorage.removeItem("jwt");
                    next({ name: 'Home' })
                } else {
                    next()
                }
            } catch (error) {
                console.log("Token not valid");
                localStorage.removeItem("jwt");
                next({ name: 'Home' })
            }
        } else {
            console.log("goto home !")
            next({ name: 'Home' })
        }
    } else {
        next()
    }
})
export default router
